import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
} from '@mui/material'
import { ReactNode } from 'react'

type WarningModalProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  message?: string
  children?: ReactNode
  confirmText?: string
  cancelText?: string
  isDisabled?: boolean
}

export default function WarningModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  children,
  confirmText = 'Yes, Continue',
  cancelText = 'Cancel',
  isDisabled = false,
}: WarningModalProps) {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {message && <Typography sx={{ mb: 2 }}>{message}</Typography>}
        {children && <Box>{children}</Box>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isDisabled}>
          {cancelText}
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={onConfirm}
          disabled={isDisabled}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
